import { selectDataOra, selectNumeroCorsa, selectSiglaRiunione, selectTipoGara, selectTipoIppica } from '../selectors';

import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useTypedSelector } from 'lib/centralStore';

export const useCodProgrammaIdAvvenimentoByRouter = () => {
  const { query } = useRouter();
  const { details } = query; // codiceProgramma-idAvvenimento;

  return useMemo(() => {
    const [idProgramma, idAvvenimento] = String(details).split('-', 2); // [idProgramma,idAvvenimento]
    return { idProgramma, idAvvenimento };
  }, [details]);
};

export const useCreateStatsPathByNumCavallo = (numeroCavallo: number) => {
  const tipoGara = useTypedSelector(selectTipoGara);
  const tipoIppica = useTypedSelector(selectTipoIppica);
  const numeroCorsa = useTypedSelector(selectNumeroCorsa);
  const siglaRiunione = useTypedSelector(selectSiglaRiunione);
  const dataOraAvvenimento = useTypedSelector(selectDataOra);

  return useMemo(() => {
    // TODO : FORMATTING
    const date = dataOraAvvenimento ? new Date(dataOraAvvenimento) : new Date();
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const stringDate = [year, month, day].join('-');

    const CODE = `${tipoGara ?? ''}`.toUpperCase().split('').shift();

    switch (tipoIppica) {
      case 1:
      case 2: {
        const sigla = `${siglaRiunione ?? ''}`.substring(0, 2);
        return `${process.env.NEXT_PUBLIC_IPPICA_SINTESI}/${CODE}/${sigla}/${stringDate}/${numeroCorsa}/${numeroCavallo}`;
      }
      case 3: {
        return `${process.env.NEXT_PUBLIC_IPPICA_SINTESI}/${CODE}/${siglaRiunione}/${stringDate}/${numeroCorsa}/${numeroCavallo}`;
      }
    }

    return '';
  }, [dataOraAvvenimento, numeroCavallo, numeroCorsa, siglaRiunione, tipoGara, tipoIppica]);
};
